import { envValue } from './env'

// Whether "Create an account" sets up a BUSINESS (a new tenant) or a client's own
// account. Client, unless a deployment sets EXPO_PUBLIC_SELF_SERVE_SIGNUP=true:
// clients on porter.innoshape.com.au were creating businesses (2026-10-19).
export function businessSignupEnabled(): boolean {
  return envValue(process.env.EXPO_PUBLIC_SELF_SERVE_SIGNUP) === 'true'
}
